import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify";
import i18n from "./i18n";
import axios from "axios";
import VueAxios from "vue-axios";
// import { config } from "../config";

Vue.use(VueAxios, axios);
Vue.use(Vuetify);
//eslint-disable-next-line no-undef
// console.log(config())
Vue.config.productionTip = false;

// fetch("/../static/config.json")

// new Vue({
//   vuetify,
//   store,
//   router,
//   i18n,
//   render: (h) => h(App),
// }).$mount("#app");

axios
  .get("/config.json")
  .then((res) => {
    console.log(res);
    axios.defaults.baseURL = res.data.VUE_APP_API_FAMILY;
    localStorage.setItem("url", res.data.VUE_APP_API_FAMILY);
    Vue.prototype.$urlLoginOauth = res.data.VUE_APP_SRITRANG_LOGIN_URL;
    Vue.prototype.$tokenOauth = res.data.VUE_APP_SRITRANG_LOGIN_TOKEN;
    new Vue({
      vuetify,
      store,
      router,
      i18n,
      render: (h) => h(App),
    }).$mount("#app");
  })
  .catch((error) => {
    console.log(error);
    axios.defaults.baseURL = process.env.VUE_APP_API_FAMILY;
    localStorage.setItem("url", process.env.VUE_APP_API_FAMILY);
    Vue.prototype.$urlLoginOauth = process.env.VUE_APP_SRITRANG_LOGIN_URL;
    Vue.prototype.$tokenOauth = process.env.VUE_APP_SRITRANG_LOGIN_TOKEN;
    new Vue({
      vuetify,
      store,
      router,
      i18n,
      render: (h) => h(App),
    }).$mount("#app");
  });
